import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import {  Row, Col } from 'react-flexbox-grid'
import { Card, Form, Icon, Image, Message, Divider } from 'semantic-ui-react'
import { sendVerificationEmail } from '../../actions/actionCreators'
import Logo from '../../images/logo-admin.png'
import { Text, Translate, LanguageContext } from '../../helpers/language';

const queryString = require('query-string');



class SendVerificationEmail extends React.Component {  

  constructor(props) {
    super(props);
    const parsed = queryString.parse(props.location.search);
    const email = parsed.email ? parsed.email : ''
    this.state = {
        email: email
      };
  }

  componentDidMount () {  
    if (!this.state.email) {
      this.props.history.push('/');
      return;
    }
    window.dataLayer.push({
      event: 'page_view',
      page: {
        url: document.location.pathname,
        title: 'Verification Email Form'
      }
    });

    this.props.dispatch(sendVerificationEmail( {email: this.state.email} )) 
  }

  sendNewVerification = (event) => {
    event.preventDefault()
    window.dataLayer.push({
      event: 'user_event',
      eventProps: {
        category: 'user_action',
        action: 'verification_email_sent',
        label: 'User Verification Email Sent',
        value: 'true'
      }
    });
    this.props.dispatch(sendVerificationEmail( {email: this.state.email} ))    
  }

  render() {
    const message = this.props.verifyEmail && this.props.verifyEmail.message ? Translate(this.context, this.props.verifyEmail.message) : ''
    const messageStatus = message && message.length > 0 ? true : false
    if (!this.state.email)
      return(null);
    return (     
      <div className="lisia-dialog lisia-centered-dialog">
        <Row center="xs">
          <Col classname='send-verification-email-wrapper' xs={11} sm={6} md={4}>
            <Card fluid={true} raised={true} centered={true}>
              <Card.Content>
                <div className="loginForm">
                  <Image size='small' src={ Logo } className='m-b-10'/>
                  <Form >
                    <h3 className='text-center'><Text tid='send_verification_email_panel_title' /></h3>         
                    <Divider />
                    <div className='send_verification_email_panel_body'>
                      {Translate(this.context, 'send_verification_email_panel_body').replace(/\${email}/, this.state.email)}                  
                    </div>
                    <br></br>
                    <div className='send_verification_email_alert_body'>
                      {Translate(this.context, 'send_verification_email_alert_body')}                  
                    </div>
                    <div className='send_verification_email_message'>
                      <Form.Field>
                        <Message hidden={!messageStatus} visible={messageStatus} icon>
                          <Icon name='info sign' />
                          <Message.Content>
                          { message }
                          </Message.Content>
                        </Message>
                      </Form.Field>      
                    </div>            
                    <Divider />   
                    <div className='footer'>      
                      <Link to='/login' style={{float: 'left'}}>
                        <Text tid="go_to_login" />
                      </Link>
                      <Link onClick={this.sendNewVerification.bind(this)} style={{float: 'right'}}>
                        <Text tid="no_email_received" />
                      </Link>                        
                    </div>
                  </Form>
                </div>
              </Card.Content>
            </Card>
          </Col>
        </Row>           
      </div>  
    )
  }
}

SendVerificationEmail.contextType = LanguageContext;

SendVerificationEmail.propTypes = {

}

const mapStateToProps = (state) => ({
  verifyEmail: state.verifyEmail
})

export default connect(mapStateToProps)(SendVerificationEmail)
